import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { AssetModalPanelContainer } from "~/components/AssetModal/Panel/Content/Container";
import { CustomFieldsPanel } from "~/components/AssetModal/Panel/Content/ContentRenderer/components/CustomFieldsPanel";
import { AssetCustomFieldsPanelContent } from "~/components/RightPanel/CustomFields/AssetCustomFieldsPanelContent";
import { PublicAssetPanelCustomFieldDateInput } from "~/components/RightPanel/CustomFields/PublicAssetPanelCustomFieldDateInput";
import { PublicAssetPanelCustomFieldPlainText } from "~/components/RightPanel/CustomFields/PublicAssetPanelCustomFieldPlainText";
import { PublicAssetPanelCustomFieldSelect } from "~/components/RightPanel/CustomFields/PublicAssetPanelCustomFieldSelect";
import { usePublicAssetCustomFieldsData } from "~/hooks/usePublicAssetCustomFieldsData";
export const PublicCustomFieldsPanelContainer = /*#__PURE__*/ memo(()=>{
    const { data: customFields } = usePublicAssetCustomFieldsData();
    const fields = useMemo(()=>/*#__PURE__*/ _jsx(AssetCustomFieldsPanelContent, {
            fields: customFields === null || customFields === void 0 ? void 0 : customFields.data,
            SelectCustomField: PublicAssetPanelCustomFieldSelect,
            DateCustomField: PublicAssetPanelCustomFieldDateInput,
            PlainTextCustomField: PublicAssetPanelCustomFieldPlainText
        }), [
        customFields === null || customFields === void 0 ? void 0 : customFields.data
    ]);
    const panel = useMemo(()=>/*#__PURE__*/ _jsx(CustomFieldsPanel, {
            fields: fields
        }), [
        fields
    ]);
    return /*#__PURE__*/ _jsx(AssetModalPanelContainer, {
        title: "CUSTOM FIELDS",
        panel: panel
    });
});
PublicCustomFieldsPanelContainer.displayName = "PublicCustomFieldsPanelContainer";
